export const getTimeByISO = (iso: string) => new Date(iso).getTime()
export const toISOFromTimestamp = (timestamp: number) => new Date(timestamp).toISOString()
